import { Box, Paper } from "@mui/material";
import Header from "../../components/global/Header";
import { HeadCells } from "../../data/SubscriberData";
import Table from "../../components/global/TableComponent";
import { useState, useEffect } from "react";
import Popup from "../../components/global/PopUp";
import QueryResponse from "./QueryResponse";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import EditSubscriber from "./EditSubscriber";
import axios from "axios";
import Error404 from "../../pages/Error404";
const messageFormConfig = [
  {
    field: {
      type: "text",
      title: "Subject",
      name: "subject",
      placeholder: "Provide Subject",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Field is required",
      },
    },
  },
  {
    field: {
      type: "text",
      title: "Message",
      name: "message",
      placeholder: "Type your message...",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Field is required",
      },
    },
  },
];

function Subscriber({ role }) {
  const [openPopup, setOpenPopup] = useState(false);
  const [editId, setEditId] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [subscribers, setSubscribers] = useState([]);

  const edit = editId != null;
  const formFieldValues = edit ? editId : null;
  console.log("Field Data", formFieldValues);

  const deleteRecord = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Pass the data in an object
          const response = await axios.delete(
            "http://127.0.0.1:8000/admins/delete-subscriber",
            { data: { id: id } }
          );
          if (response.status === 200) {
            toast.success("Successfully deleted the record");
            GetSubscribers();
          } else {
            toast.error("Operation not Completed", response.data);
          }
        } catch (error) {
          toast.error("Operation not Completed");
        }
      }
    });
  };
  const handleSend = async (formData) => {
    const updatedData = {
      ...formFieldValues,
      ...formData,
    };
    console.log(updatedData);
    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/admins/send-mail",
        updatedData
      );

      // Handle response based on server's response
      if (response.status === 200) {
        // Handle successful creation of user
        toast.success("Email send successfully");
        setOpenPopup(false);
      } else {
        toast.error("Failed to send email!!");
      }
    } catch (error) {
      toast.error("Failed to send email");
    }
  };

  const handleUpdate = async (formData) => {
    console.log("Form Data:", formData);

    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/admins/update-Subscriber",
        formData
      );

      // Handle response based on server's response
      if (response.status === 200) {
        // Handle successful creation of user
        console.log("Subscriber Updated successfully:", response.data);
        GetSubscribers();
      } else {
        console.error("Error:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }

    setIsEdit(false);
    setOpenPopup(false);
  };

  useEffect(() => {
    GetSubscribers();
    return () => {
      // Cleanup code, if needed
    };
  }, []);
  const GetSubscribers = async () => {
    try {
      const response = await axios.get(
        "http://127.0.0.1:8000/admins/get-all-subscribers"
      );

      if (response.status === 200) {
        console.log(
          "Subscribers fetched successfully:",
          response.data.subscribers
        );

        setSubscribers(response.data.subscribers);
      } else {
        console.error("Error:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {role === "admin" ? (
        <Box m={"2vw"}>
          <Header
            title="Subscribers"
            subTitle="List of all the user with their bot subscription plan details"
          />
          <Paper
            style={{
              background: "#201939eb",
              padding: "2vh 2vw",
            }}
          >
            <Table
              tableHeaders={HeadCells}
              data={subscribers}
              buttons={[
                {
                  btnName: "Edit",
                  bg: "var(--iris-60)",
                },
                { btnName: "Delete", bg: "var(--red)" },
                {
                  btnName: "Message",
                  bg: "var(--color-darkslateblue)",
                },
              ]}
              addAction={() => setOpenPopup(true)}
              setEditId={setEditId}
              deleteRecord={deleteRecord}
              setEdit={setIsEdit}
            />
          </Paper>
          {isEdit ? (
            <Popup
              title={"Edit Subscriber Details"}
              openPopup={openPopup}
              setEdit={setIsEdit}
              setOpenPopup={setOpenPopup}
            >
              <EditSubscriber
                handleUpdate={handleUpdate}
                closePopup={() => setOpenPopup(false)}
                formFieldValues={formFieldValues}
                role={role}
              />
              <Toaster />
            </Popup>
          ) : (
            <Popup
              title={"Send Message"}
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <QueryResponse
                handleAddOrUpdate={handleSend}
                closePopup={() => setOpenPopup(false)}
                messageFormConfig={messageFormConfig}
              />
              <Toaster />
            </Popup>
          )}
        </Box>
      ) : (
        <Error404 />
      )}
    </>
  );
}

export default Subscriber;
